<template><div><h1>VUX V2.2.1 released</h1>
<h2><a href="/en/components/x-number.html">XNumber</a></h2>
<ul><li>[fix] delete prop-check-warning message, and disable `add` and `sub` method when `value` is empty string</li>
</ul></div></template><script>
export default {
  head: {"title":"VUX V2.2.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.2.1-98.vue?423e740c